import styled, { css } from 'styled-components'

import Tooltip from '../Tooltip'

export const ContainerCustom = styled.div<{ erro?: boolean }>`
  p.error-checkbox {
    @media (max-width: 1200px) {
      display: none;
    }
    position: absolute;
    margin-top: 50px;
    color: #ff3366;
  }
  input {
    border: ${props => props.erro && '1px solid red !important'};
    color: ${props => (props.erro ? 'red !important' : '#5E6278 !important')};
  }
  label {
    color: ${props => (props.erro ? 'red !important' : '#5E6278 !important')};
  }
  svg {
    margin-right: 16px;
  }
`

export const Contanier = styled.div<{ erro?: boolean }>`
  border-radius: 10px;
  margin-bottom: 1em;

  > label {
    font-weight: normal;
  }

  & > div {
    position: relative;
  }

  input {
    flex: 1;
    background: transparent;
    border: 1px solid #c2cad8;
    padding-right: 30px;
    border: ${props => props.erro && '1px solid red !important'};
    color: ${props => (props.erro ? 'red !important' : '#5E6278 !important')};
    &::placeholder {
      color: #666360;
    }
  }

  p.error {
    @media (max-width: 1200px) {
      display: none;
    }
    position: absolute;
    bottom: -22px;
    color: #ff3366;
  }

  svg {
    margin-right: 16px;
  }
`

export const Error = styled(Tooltip)`
  @media (max-width: 1200px) {
    display: none;
  }
  height: 20px;
  width: fit-content;
  position: absolute;
  right: 20px;
  top: 50%;
  margin: 0;
  transform: translateY(-50%);
  svg {
    margin: 0;
  }

  span {
    width: max-content;
    background: #c53030;
    color: #fff;
    transform: translateX(-50%);
    &::before {
      border-color: #c53030 transparent;
    }
    ${props =>
      props.position === 'left' &&
      css`
        transform: translateX(-90%);
        &::before {
          left: 90%;
        }
      `}
  }
`

export const SelectContanier = styled.div<{ erro?: boolean }>`
  border-radius: 10px;
  margin-bottom: 1em;

  > label {
    font-weight: normal;
  }

  select {
    width: 100%;

    border: ${props => props.erro && '1px solid red !important'};
    color: ${props => (props.erro ? 'red !important' : '#5E6278 !important')};

    option:disabled {
      display: none;
    }
  }

  p.error {
    @media (max-width: 1200px) {
      display: none;
    }
    position: absolute;
    margin-top: 80px;
    color: #ff3366;
  }
`

export const SelectSearchContainer = styled.div<{ erro?: boolean }>`
  border-radius: 10px;
  margin-bottom: 1em;

  > label {
    font-weight: normal;
  }

  input {
    width: 100%;
    border: ${props => props.erro && '1px solid red !important'};
    color: ${props => (props.erro ? 'red !important' : '#5E6278 !important')};
    padding-right: 30px;
    position: relative;

    &:focus {
      outline: none;
      border-color: #3c4cc7;
      box-shadow: 0 0 0 1px #3c4cc7;
    }

    &::placeholder {
      color: #9ca3af;
    }
  }

  p.error {
    @media (max-width: 1200px) {
      display: none;
    }
    position: absolute;
    margin-top: 80px;
    color: #ff3366;
  }
`

export const ArrowIcon = styled.div<{ isOpen: boolean }>`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%)
    ${props => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease;
  pointer-events: none;
  z-index: 2;

  svg {
    width: 12px;
    height: 8px;
    color: #5e6278;
  }
`

export const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #f5f8fa;
  border: 1px solid #c2cad8;
  border-radius: 1px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1050;
  margin-top: 1px;
`

export const DropdownItem = styled.div<{ disabled?: boolean }>`
  padding: 12px 16px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  color: ${props => (props.disabled ? '#9ca3af' : '#5E6278')};
  background: #f5f8fa;
  transition: background-color 0.1s ease;

  &:hover {
    background: ${props => (props.disabled ? 'white' : '#3c4cc7')};
    color: ${props => (props.disabled ? '#9ca3af' : 'white')};
  }

  &:not(:last-child) {
    border-bottom: 1px solid #e9ecef;
  }
`

export const NoOptionsMessage = styled.div`
  padding: 12px 16px;
  color: #6c757d;
  font-style: italic;
  text-align: center;
`

export const TextAreaContanier = styled.div<{ erro?: boolean }>`
  border-radius: 10px;
  margin-bottom: 1em;

  > label {
    font-weight: normal;
  }

  textarea {
    width: 100%;
    padding: 5px;

    border: ${props => props.erro && '1px solid red !important'};
    color: ${props => (props.erro ? 'red !important' : '#5E6278 !important')};

    option:disabled {
      display: none;
    }
  }
  p.error {
    @media (max-width: 1200px) {
      display: none;
    }
    position: absolute;
    margin-top: 12px;
    color: #ff3366;
  }
`
export const DatePickerContainer = styled.div<{ erro?: boolean }>`
  border-radius: 10px;
  margin-bottom: 1em;

  > label {
    font-weight: normal;
  }

  input {
    flex: 1;
    background: transparent;
    border: 1px solid #c2cad8;
    padding-right: 30px;

    &::placeholder {
      color: #666360;
      color: ${props => (props.erro ? 'red !important' : '#5E6278 !important')};
    }
    border: ${props => props.erro && '1px solid red !important'};
    color: ${props => (props.erro ? 'red !important' : '#5E6278 !important')};
  }
  & > div {
    position: relative;
  }

  .react-datepicker,
  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    font-size: 12px;
  }
  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    margin: 7px;
  }

  p.error {
    @media (max-width: 1200px) {
      display: none;
    }
    position: absolute;
    bottom: -22px;
    color: #ff3366;
  }
`
